import "./common/fonts/AktivGroteskEx_A_Bd-normal";
import "./common/fonts/AktivGroteskEx_A_Lt-normal";
import "./common/fonts/AktivGroteskEx_A_Md-normal";
import "./common/fonts/AktivGroteskEx_A_Rg-normal";
import "./common/fonts/AktivGroteskEx_A_XBd-normal";
import "./common/fonts/Poppins-Light-normal";

import ThemeProvider from "./providers/ThemeProvider";
import RootNavigation from "./navigation/RootNavigation";
import { AppStoreProvider } from "./providers/AppStore";
import AuthProvider from "./providers/AuthProvider";
import useScreenInfo from "./providers/useScreenInfo";
import { ClientSidePanelProvider } from "./providers/ClientSidePanelProvider";
import { ScoreSidePanelProvider } from "./modules/platform/components/score/ScoreSidePanelContext";

function App() {
  // const { orientation } = useScreenInfo();

  return (
    <AuthProvider>
      <ThemeProvider>
        <AppStoreProvider>
          <ClientSidePanelProvider>
            <ScoreSidePanelProvider>
              <RootNavigation />
            </ScoreSidePanelProvider>
          </ClientSidePanelProvider>
        </AppStoreProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
